export const internalAnchorOffset = 80;
